//Single Click Reviews Badge Handler
if (!window.reviewsBadgeHandlerInitialized) {
  window.reviewsBadgeHandlerInitialized = true;

  document.addEventListener('DOMContentLoaded', function () {
    const reviewBadges = document.querySelectorAll('.jdgm-preview-badge');

    // scroll animation
    function startStableScroll(reviewsWrapper) {
      try {
        const currentScrollY = window.scrollY;
        const reviewsRect = reviewsWrapper.getBoundingClientRect();
        const targetScrollY = currentScrollY + reviewsRect.top - 120;

        const lockedTargetScrollY = targetScrollY;
        const scrollDistance = Math.abs(lockedTargetScrollY - currentScrollY);
        const duration = Math.min(Math.max(scrollDistance / 1.5, 600), 1500);

        window.scrollTo({
          top: lockedTargetScrollY,
          behavior: 'smooth'
        });

        setTimeout(function () {
          reviewsWrapper.classList.add('reviews-highlight');
          setTimeout(function () {
            reviewsWrapper.classList.remove('reviews-highlight');
          }, 2000);
        }, duration + 100);
      } catch (error) {
        try {
          const reviewsRect = reviewsWrapper.getBoundingClientRect();
          const targetScrollY = window.scrollY + reviewsRect.top - 120;
          window.scrollTo({
            top: targetScrollY,
            behavior: 'instant'
          });
        } catch (fallbackError) { }
      }
    }

    // Badge click handler function
    function handleBadgeClick(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      e.cancelBubble = true;
      e.returnValue = false;

      const reviewsWrapper = document.querySelector('.reviews__wrapper');
      if (!reviewsWrapper) return false;

      const accordion = reviewsWrapper.querySelector('wyatt-accordion');
      if (!accordion) return;

      const accordionTrigger = accordion.querySelector('.accordion__trigger');
      if (!accordionTrigger) return;

      const isOpen = accordionTrigger.getAttribute('active') === 'true';

      if (!isOpen) {
        try {
          accordionTrigger.setAttribute('active', 'true');
          accordionTrigger.setAttribute('aria-expanded', 'true');
          const panel = accordion.querySelector('.accordion__panel');
          if (panel) panel.setAttribute('active', 'true');
          accordion.dispatchEvent(new CustomEvent('accordion-opened', {
            detail: { accordion: accordion }
          }));
        } catch (error) {
          accordionTrigger.click();
        }
        setTimeout(function () {
          startStableScroll(reviewsWrapper);
        }, 800);
      } else {
        startStableScroll(reviewsWrapper);
      }
      return false;
    }

    // Attach to existing badges
    reviewBadges.forEach(function (badge) {
      const newBadge = badge.cloneNode(true);
      badge.parentNode.replaceChild(newBadge, badge);
      newBadge.addEventListener('click', handleBadgeClick, true);
    });

    // MutationObserver for new badges added to the DOM
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const newBadges = node.querySelectorAll ? Array.from(node.querySelectorAll('.jdgm-preview-badge')) : [];
              if (node.classList && node.classList.contains('jdgm-preview-badge')) {
                newBadges.push(node);
              }

              newBadges.forEach(function (badge) {
                if (!badge.hasAttribute('data-reviews-handler-attached')) {
                  badge.setAttribute('data-reviews-handler-attached', 'true');
                  const newBadge = badge.cloneNode(true);
                  badge.parentNode.replaceChild(newBadge, badge);
                  newBadge.addEventListener('click', handleBadgeClick, true);
                }
              });
            }
          });
        }
      });
    });

    // Observe the body for new badges added to the DOM
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

  });
}